import { MODULE_NAME } from './constants';

export const UPDATE_INFO = `${MODULE_NAME}/UPDATE_INFO`;
export function updateInfo(payload) {
	return { type: UPDATE_INFO, payload };
}

export const SET_LAUNCH_SOURCE = `${MODULE_NAME}/SET_LAUNCH_SOURCE`;
export function setLaunchSource(payload) {
	return { type: SET_LAUNCH_SOURCE, payload };
}

/**
 * Mobile specific
 * Action is handled in packages/self-care-mob-app/src/modules/mobile/middleware.js
 */
export const BIOMETRIC_AUTH_DECLINE = `${MODULE_NAME}/BIOMETRIC_AUTH_DECLINE`;
export function biometricAuthDeclineAction() {
	return { type: BIOMETRIC_AUTH_DECLINE, payload: {} };
}

/**
 * Mobile specific
 * Action is handled in packages/self-care-mob-app/src/modules/mobile/middleware.js
 */
export const BIOMETRIC_LOGIN = `${MODULE_NAME}/BIOMETRIC_LOGIN`;
export function biometricLoginAction(payload) {
	return { type: BIOMETRIC_LOGIN, payload };
}

/**
 * Mobile specific
 * Action is handled in packages/self-care-mob-app/src/modules/mobile/middleware.js
 */
export const BIOMETRIC_AUTH_SET = `${MODULE_NAME}/BIOMETRIC_AUTH_SET`;
export function biometricAuthSetAction() {
	return { type: BIOMETRIC_AUTH_SET, payload: {} };
}

/**
 * Mobile specific
 * Instructs the middleware whether to use dark mode UI.
 */
export const SET_IS_DARK_MODE = `${MODULE_NAME}/SET_IS_DARK_MODE`;
export const setIsDarkMode = (isDarkMode) => ({
	type: SET_IS_DARK_MODE,
	payload: { isDarkMode },
});

/**
 * Mobile specific
 * Instructs the middleware whether to use dark mode UI.
 */
export const DARK_MODE_CHANGED = `${MODULE_NAME}/DARK_MODE_CHANGED`;
export const darkModeChanged = (isDark) => ({
	type: DARK_MODE_CHANGED,
	payload: { isDark },
});

/**
 * Mobile specific
 */
export const PIN_CREATE = `${MODULE_NAME}/PIN_CREATE`;
export function pinCreate({ mobileToken, pin }) {
	return { type: PIN_CREATE, payload: { mobileToken, pin } };
}

/**
 * Mobile specific
 */
export const PIN_LOGIN = `${MODULE_NAME}/PIN_LOGIN`;
export function pinLogin({ pin }) {
	return { type: PIN_LOGIN, payload: { pin } };
}

/**
 * Mobile specific
 */
export const PIN_VERIFICATION = `${MODULE_NAME}/PIN_VERIFICATION`;
export function pinVerification({ pin }) {
	return { type: PIN_VERIFICATION, payload: { pin } };
}

/**
 * Mobile specific
 */
export const RETRIEVE_INFO = `${MODULE_NAME}/RETRIEVE_INFO`;
export function retrieveInfo(resolvePathAfterFinish) {
	return { type: RETRIEVE_INFO, payload: { resolvePathAfterFinish } };
}

/**
 * Mobile specific
 * Forces update of the `isPrimaryDevice` state
 */
export const UPDATE_PRIMARY_DEVICE = `${MODULE_NAME}/UPDATE_PRIMARY_DEVICE`;
export const updatePrimaryDeviceAction = () => ({ type: UPDATE_PRIMARY_DEVICE });

/**
 * Mobile specific
 * Triggers refresh of current device's waiting authorizations. Is no-op when device is not primary.
 */
export const DEVICE_AUTHORIZATIONS_CHECK = `${MODULE_NAME}/DEVICE_AUTHORIZATIONS_CHECK`;
export const deviceAuthorizationsCheckAction = () => ({ type: DEVICE_AUTHORIZATIONS_CHECK });

/**
 * Mobile specific
 * Initiates intercepting of device authorizations, it is turned off initially.
 */
export const DEVICE_AUTHORIZATIONS_LISTEN = `${MODULE_NAME}/DEVICE_AUTHORIZATIONS_LISTEN`;
export const deviceAuthorizationsListenAction = (enable) => ({
	type: DEVICE_AUTHORIZATIONS_LISTEN,
	payload: { enable: Boolean(enable) },
});

/**
 * Mobile specific
 */
export const NATIVE_BACK_ENABLE = `${MODULE_NAME}/NATIVE_BACK_ENABLE`;
export function nativeBackEnable() {
	return { type: NATIVE_BACK_ENABLE, payload: {} };
}

/**
 * Mobile specific
 */
export const NATIVE_BACK_DISABLE = `${MODULE_NAME}/NATIVE_BACK_DISABLE`;
export function nativeBackDisable() {
	return { type: NATIVE_BACK_DISABLE, payload: {} };
}

/**
 * Mobile specific
 * Enables or disables push notifications.
 */
export const CHANGE_PUSH_NOTIFICATION_STATE = `${MODULE_NAME}/CHANGE_PUSH_NOTIFICATION_STATE`;
export const changePushNotificationState = (newState) => ({
	type: CHANGE_PUSH_NOTIFICATION_STATE,
	payload: { isEnabled: newState },
});

export const SET_STATUS_BAR_COLOR = `${MODULE_NAME}/SET_STATUS_BAR_COLOR`;
/**
 * Instructs the middleware to sets color of status bar on mobile device to light or dark color.
 * @param {boolean} useLightColorTone
 */
export const setStatusBarColor = (useLightColorTone) => ({
	type: SET_STATUS_BAR_COLOR,
	payload: { useLightColorTone },
});

export const SHARE_FILE = `${MODULE_NAME}/SHARE_FILE`;
/**
 * Instructs the middleware to perform File Share operation. If environment supports file sharing,
 * dispatching of this action returns Promise
 */
export const shareFile = (shareOptions) => ({
	type: SHARE_FILE,
	payload: shareOptions,
});

export const SHARE_URL = `${MODULE_NAME}/SHARE_URL`;
/**
 * Instructs the middleware to perform URL Share operation. If environment supports Share API,
 * dispatching of this action returns Promise
 * @param {import('@capacitor/core').ShareOptions} shareOptions
 * @see https://capacitorjs.com/docs/apis/share#shareoptions
 */
export const shareUrl = (shareOptions) => ({
	type: SHARE_URL,
	payload: shareOptions,
});

export const PAYMENT_REDIRECT = `${MODULE_NAME}/PAYMENT_REDIRECT`;
export const paymentRedirect = ({ gatewayRedirectUrl, redirectUrls }) => ({
	type: PAYMENT_REDIRECT,
	payload: { gatewayRedirectUrl, redirectUrls },
});

/**
 * Experimental sibling of `paymentRedirect` for non-payment external handoff
 * (BankID, PSD2 consent, etc.). Gated on `STORAGE_KEY_EXPERIMENTAL_EXTERNAL_REDIRECT`.
 *
 * `openIn`: `'in-app-browser'` (default) uses a Cordova InAppBrowser with
 * `loadstart` intercept. `'system-browser'` hands off to the OS browser —
 * required for bank / PSD2 pages that refuse to render in the embedded
 * WKWebView; return-to-app then relies on Universal Links + an `appStateChange`
 * listener on the caller side.
 */
export const EXTERNAL_REDIRECT = `${MODULE_NAME}/EXTERNAL_REDIRECT`;
export const externalRedirect = ({ gatewayRedirectUrl, redirectUrls, openIn }) => ({
	type: EXTERNAL_REDIRECT,
	payload: { gatewayRedirectUrl, redirectUrls, openIn },
});

export const APP_REVIEW = `${MODULE_NAME}/appReview`;
export const appReviewAction = () => ({ type: APP_REVIEW });

export const NATIVE_CONFIRM_DIALOG = `${MODULE_NAME}/nativeConfirmDialog`;
export const nativeConfirmDialogAction = ({
	message,
	title,
	okButtonTitle,
	cancelButtonTitle,
}) => ({
	type: NATIVE_CONFIRM_DIALOG,
	payload: {
		message,
		title,
		okButtonTitle,
		cancelButtonTitle,
	},
});
